module.exports = __webpack_public_path__ + "static/media/pc1.11919ccc.png";